import $ from 'jquery';
import ReportController from './report.controller';

export default class GroupsReportController extends ReportController
{
	get endpoint() {
		return 'groups';
	}

	get title() {
		return 'Groups Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/groups.report.controller.js
 **/